import React from 'react'

import AnimatedLoadingDots from '~components/Common/Basics/MicroAnimations/AnimatedLoadingDots/AnimatedLoadingDots'
import DecoratedHeading from '~components/Common/DecoratedHeading/DecoratedHeading'
import { useOnboarding } from './Onboarding.hooks'

import './Onboarding.scss'

const Onboarding: TOnboarding = () => {
	useOnboarding()

	return (
		<div className="Onboarding">
			<div>
				<DecoratedHeading h={1}>
					Configuration de votre site internet
					<AnimatedLoadingDots />
				</DecoratedHeading>

				<p>
					Nous préparons les derniers détails... Cette étape ne prend
					généralement que quelques secondes.
				</p>
			</div>
		</div>
	)
}

export default Onboarding

type TOnboarding = React.FC
